module.exports = __webpack_public_path__ + "assets/img/teacher (52).3929b7a5.png";